
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 154 154","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"77","cy":"77","r":"76.2","fill":"#00a8e9"}}),_c('path',{staticClass:"st1",attrs:{"fill":"#FFF","d":"M52.9 68.5h48.4v4.8H52.9zM52.9 86.7h48.4v4.8H52.9zM52.9 104.8h48.4v4.8H52.9z"}}),_c('path',{staticClass:"st1",attrs:{"d":"M119.3 55.4L96.2 32.2l-4.8-4.8H29.8v99.2h94.4V60.2l-4.9-4.8zM96.2 39.1l16.3 16.3H96.2V39.1zm23.1 82.7H34.7V32.2h56.7v28h28v61.6z","fill":"#FFF"}})])
          )
        }
      }
    